import { Quote, Sparkles } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';

interface KeyVerseCandidate {
    ref: string;
    why: string;
}

interface KeyVerseCandidatesCardProps {
    candidates: KeyVerseCandidate[];
    isExpanded: boolean;
    onToggleExpansion: () => void;
    onRefClick?: (ref: string) => void;
    thumbnailUrl?: string;
}

export function KeyVerseCandidatesCard({ candidates, isExpanded, onToggleExpansion, onRefClick, thumbnailUrl }: KeyVerseCandidatesCardProps) {
    if (!candidates || candidates.length === 0) return null;

    return (
        <DiscoveryCard
            isExpanded={isExpanded}
            onToggle={onToggleExpansion}
            icon={Quote}
            thumbnailUrl={thumbnailUrl}
            header={
                <div className="flex flex-col gap-1">
                    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/50">Canonical Markers</div>
                    <h3 className="text-xl font-serif font-medium text-foreground/90 leading-tight">Signature Verses</h3>
                </div>
            }
        >
            <div className="pt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                {candidates.map((verse, index) => (
                    <div
                        key={index}
                        className="relative group/verse p-4 transition-all"
                    >
                        <div className="flex items-start justify-between gap-2 mb-2">
                            <span
                                className="text-xs font-mono font-bold text-primary/60 cursor-pointer hover:text-primary transition-colors flex items-center gap-1"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onRefClick(verse.ref);
                                }}
                            >
                                <Quote className="h-3 w-3" />
                                {verse.ref}
                            </span>
                        </div>
                        <p className="text-sm text-foreground/80 font-light leading-relaxed italic">
                            "{verse.why}"
                        </p>
                    </div>
                ))}
            </div>
        </DiscoveryCard>
    );
}
